import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-replacement",
  "use": "icon-replacement-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-replacement\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M14 9v2l-8.761-.001 1.278 2.554-1.789.894L2.005 9H14zm-2.702-7.447L14.022 7H2V5l8.785-.001-1.276-2.552 1.79-.894z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol